// React imports.
import React, { Component } from "react";

// App imports.
import { BreadCrumbsCurrentStepEnum } from "../state";


const Breadcrumbs = ({ currentStep }) => (
     <div className="steps">
          <div className={"step " + (currentStep == BreadCrumbsCurrentStepEnum.Topics ? "active":"completed")} data-id="1" title="Step one is to choose a topic to report on">
               <span>1</span> Start: Topics
          </div>
          <div className={"step " + (currentStep == BreadCrumbsCurrentStepEnum.States ? "active" : "completed")} data-id="2" title="Step two is to choose states to report on">
               <span>2</span> States
          </div>
          <div className={"step " + (currentStep == BreadCrumbsCurrentStepEnum.Years ? "active" : "completed")}  data-id="3" title="Step three is to choose fiscal years to report on">
               <span>3</span> Years
          </div>

          <div className="step laststepgray" title="Step four is viewing results.">
               <span>4</span> Results
          </div>
     </div>
);

export default Breadcrumbs;
